import type { DataTableColumn } from '@/components/common/DataTable';
import {
  FLEET_COLUMN_FIXED_FIRST,
  FLEET_COLUMN_FIXED_LAST,
  FleetOverviewColumnPreferences,
  getDefaultFleetColumnPreferences,
} from '@/types/fleetColumnPreferences';

export function applyFleetColumnOrder<T extends object>(
  allColumns: DataTableColumn<T>[],
  prefs: FleetOverviewColumnPreferences | null | undefined
): DataTableColumn<T>[] {
  const first = allColumns.find((c) => c.key === FLEET_COLUMN_FIXED_FIRST);
  const last = allColumns.find((c) => c.key === FLEET_COLUMN_FIXED_LAST);
  const middleByKey = new Map(
    allColumns
      .filter((c) => c.key !== FLEET_COLUMN_FIXED_FIRST && c.key !== FLEET_COLUMN_FIXED_LAST)
      .map((c) => [c.key, c])
  );

  const order =
    prefs?.order?.length ? prefs.order : getDefaultFleetColumnPreferences().order;

  const orderedMiddle: DataTableColumn<T>[] = [];
  for (const key of order) {
    const col = middleByKey.get(key);
    if (col) orderedMiddle.push(col);
  }

  const result: DataTableColumn<T>[] = [];
  if (first) result.push(first);
  result.push(...orderedMiddle);
  if (last) result.push(last);
  return result;
}
